import React from "react";
import {
  InfoSection,
  Projects,
  Resume,
  ContactMe,
  AboutMe,
  Skills,
} from "../../components";

export default function Home({ light }) {
  return (
    <>
      <InfoSection id="home" light={light} />
      <AboutMe light={light} />
      <Resume id="formacion" light={light} />
      <Skills id="skills" light={light} />
      <Projects id="projects" light={light} />
      <ContactMe id="contactme" light={light} />
    </>
  );
}
